import React from 'react';

import type { Shown } from '../format';
import type { Palette } from '../palette';
import { overrideColor, seriesOverrides } from '../seriesStyle';
import type { Block, Envelope, EnvelopeColumn } from '../types';

import Breakdown from './Breakdown';

type ShareProps = { block?: Block; envelope: Envelope; palette: Palette; selected: Array<string>; onPick?: (member: string) => void; shown: Shown };

export default function Share({ block, envelope, palette, selected, onPick, shown }: ShareProps) {
  const overrides = seriesOverrides(block);
  const measure = envelope.columns.find((column) => column.role === 'measure') as EnvelopeColumn;
  const dim = envelope.columns.find((column) => column.role === 'dim') as EnvelopeColumn;
  const parts = envelope.rows
    .map((row, index) => ({
      member: String(row[dim.name]),
      value: Math.max(0, (row[measure.name] as number | null) ?? 0),
      color: overrideColor(overrides[String(row[dim.name])], palette, row.other ? palette.muted : palette.series[index % palette.series.length]),
    }))
    .filter((part) => !overrides[part.member]?.hidden);
  const whole = parts.reduce((sum, part) => sum + part.value, 0);
  const colors = new Map(parts.map((part) => [part.member, part.color]));
  return (
    <>
      {whole > 0 ? (
        <div aria-hidden className="strip">
          {parts.map((part) => (
            <i key={part.member} style={{ background: part.color, flexGrow: part.value / whole }} title={`${part.member} ${Math.round((part.value / whole) * 100)}%`} />
          ))}
        </div>
      ) : null}
      <Breakdown block={block} colors={colors} envelope={envelope} onPick={onPick} palette={palette} selected={selected} shown={shown} />
    </>
  );
}
